/**
 * lib/poModalFrame.ts
 * po-modal 枠の共通sx定数 (catalog components.css :178-194 機械転写)
 * A2裁定: 560/680/760px + 92vh (position absolute + translate(-50%,-50%) 中央配置)
 * cmd-po_1107 fix#0 — 2026-08-10
 */

/* ─── 内部ベース（直接export禁止。各幅バリアント経由で使う） ─── */
const _PO_MODAL_BASE = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "calc(100vw - 32px)",
  /** A2裁定: po-modal 92vh が部品意匠正本 */
  maxHeight: "92vh",
  bgcolor: "background.paper",
  borderRadius: "var(--radius-lg)",
  boxShadow: "var(--shadow-elevated, 0 8px 32px rgba(30, 58, 95, 0.12))",
  display: "flex",
  flexDirection: "column" as const,
  /* catalog .po-modal は overflow 未明示(visible=デフォルト)。コンテンツスクロールは sip-body の overflow-y:auto が担当 */
};

/** PC: 560px — .po-modal デフォルト */
export const PO_MODAL_SX = {
  ..._PO_MODAL_BASE,
  width: "560px",
};

/** PC: 680px — .po-modal.-w680 */
export const PO_MODAL_SX_W680 = {
  ..._PO_MODAL_BASE,
  width: "680px",
};

/** PC: 760px — .po-modal.-w760 */
export const PO_MODAL_SX_W760 = {
  ..._PO_MODAL_BASE,
  width: "760px",
};

/** SP: 画面幅 - 32px（isSmartPhone=true の全モーダル共通） */
export const PO_MODAL_SX_SP: typeof PO_MODAL_SX = {
  ..._PO_MODAL_BASE,
  width: "calc(100% - 32px)",
};
